export const UnbxdAnalyticsIdentifiers = {
  cartItemWrapper: 'unbxd-cartItemWrapper',
  addToCart: 'unbxd-addToCart',
  product: 'unbxdanalyticsProduct',
};
